<template>
  <div class="flex w-full justify-center max-w-[1440px]">
    <template v-if="!$slots.default">
      <slot name="noLayout" />
    </template>
    <div
      v-if="$slots.default"
      class="mx-2 w-full md:mx-10 xl:w-5/6 flex flex-col items-stretch justify-stretch"
    >
      <slot />
    </div>
  </div>
</template>
